import type { Schema } from '@dealdesk/api-schema';

export interface DealListParams {
  q?: string;
  sort?: string;
  page?: number;
  size?: number;
  stage?: Schema<'DealStage'>[];
  bank?: string[];
  product?: Schema<'ProductCode'>[];
  team?: string[];
  sales?: string[];
  staleDays?: number;
  mine?: boolean;
  // Architecture v2: MIS drill-through and pending-with filters
  bucket?: 'WORKING' | 'WIP' | 'APPROVED' | 'DECLINED' | 'BOOKED' | 'DISBURSED' | 'CANCELLED' | 'SUBMISSION' | 'CARRY_FORWARD' | 'NEW_SUBMISSION';
  period?: string;
  asAt?: string;
  cohort?: 'pipeline' | 'period';
  unit?: string;
  employment?: 'all' | 'employee' | 'outsourced';
  pendingWith?: Schema<'ResponsibilityType'>;
  onHold?: boolean;
  employerId?: string;
  // My deals quick views
  pendingWithMe?: boolean;
  mentions?: boolean;
}

export type DealTab = 'overview' | 'form' | 'documents' | 'operations' | 'bank-updates' | 'financial' | 'activity' | 'application' | 'bank-stage' | 'responsibility' | 'offers' | 'settlement' | 'contributors' | 'completeness' | 'calculator' | 'calculations' | 'bank-forms' | 'generated' | 'print';

export const dealKeys = {
  all: ['deals'] as const,
  lists: () => [...dealKeys.all, 'list'] as const,
  list: (p: DealListParams) => [...dealKeys.lists(), p] as const,
  /** Under lists(): every list invalidation refreshes the My deals counts too. */
  myCounts: () => [...dealKeys.lists(), 'my-counts'] as const,
  details: () => [...dealKeys.all, 'detail'] as const,
  detail: (id: string) => [...dealKeys.details(), id] as const,
  tab: (id: string, tab: DealTab, extra?: string) => [...dealKeys.detail(id), tab, ...(extra ? [extra] : [])] as const,
  lookups: ['lookups'] as const,
  configs: (bankId: string) => ['config-for-deal', bankId] as const,
  bankStages: (bankId: string) => ['bank-stages', bankId] as const,
  duplicates: (p: { customerId?: string | null; bankId?: string | null; product?: string | null; bankReference?: string | null; excludeDealId?: string | null }) => [...dealKeys.all, 'duplicates', p] as const,
  schemes: (bankId: string, product: string) => ['deal-schemes', bankId, product] as const,
  employerSearch: (q: string) => ['deal-employer-search', q] as const,
};
